import React from 'react';
import PropTypes from 'prop-types';

/**
 * CircularProgress - A circular progress indicator component
 */
function CircularProgress({
    progress = 0,
    size = 48,
    strokeWidth = 4,
    color = '#0158E6',
    backgroundColor = 'rgba(0, 168, 243, 0.2)',
    animate = true,
}) {
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;

    const strokeDashoffset = circumference * (1 - progress / 100);

    const shouldAnimate = animate && progress <= 0;

    return (
        <svg className="circular-progress-svg" width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
            {/* Background circle */}
            <circle
                cx={size / 2}
                cy={size / 2}
                r={radius}
                fill="none"
                stroke={backgroundColor}
                strokeWidth={strokeWidth}
            />

            {/* Progress circle */}
            <circle
                cx={size / 2}
                cy={size / 2}
                r={radius}
                fill="none"
                stroke={color}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeDasharray={circumference}
                strokeDashoffset={strokeDashoffset}
                transform={`rotate(-90 ${size / 2} ${size / 2})`}
                className={shouldAnimate ? 'progress-animate-circular' : 'has-progress'}
                style={{
                    transition: shouldAnimate ? 'none' : 'stroke-dashoffset 0.3s ease',
                }}
            />
        </svg>
    );
}

CircularProgress.propTypes = {
    progress: PropTypes.number,
    size: PropTypes.number,
    strokeWidth: PropTypes.number,
    color: PropTypes.string,
    backgroundColor: PropTypes.string,
    animate: PropTypes.bool,
};

export default CircularProgress;
